import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_ZONE_RESET = 'DELETE_ZONE_RESET';
export const DELETE_ZONE_LOADING = 'DELETE_ZONE_LOADING';
export const DELETE_ZONE_SUCCESS = 'DELETE_ZONE_SUCCESS';
export const DELETE_ZONE_REJECT = 'DELETE_ZONE_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteZoneReset = () => ({ type: DELETE_ZONE_RESET });
export const deleteZoneLoading = () => ({ type: DELETE_ZONE_LOADING });
export const deleteZoneSuccess = (payload) => ({ type: DELETE_ZONE_SUCCESS, payload });
export const deleteZoneReject = (payload) => ({ type: DELETE_ZONE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteZoneRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/api/Zones/${data.id}`, options);
};